import { DotLottie } from "@lottiefiles/dotlottie-web";

const benefitsSections = document.querySelectorAll(".benefits-homepage-section");

benefitsSections.forEach((section) => {
    const benefits = section.querySelectorAll(".benefit");

    benefits.forEach((benefit) => {
        const canvas = <HTMLCanvasElement>benefit.querySelector(".benefit-image");
        new DotLottie({ canvas: canvas, src: canvas.dataset.src, autoplay: true, loop: true });
    });
});
